// @flow
import React from 'react';
import { connect } from 'react-redux';
import { MdSearch } from 'react-icons/lib/md';
import i18n from 'i18n-js';

import { generateFetcher } from '../Omnisearch/utils';
import styles from './relationSearchPopover.css';
import * as selectors from '../../reducers/index';
import * as closeableActions from '../../actions/closeable';
import { RenderTypeahead } from '../FieldRenderer/index';
import OmnisearchLoadingResults from '../OmnisearchLoadingResults/index';
import { OMNISEARCH_RESULT_TYPES } from '../Omnisearch/index';
import CloseableInputSearchResult from '../CloseableInputSearchResult/index';
import OmnisearchResult from '../OmnisearchResult/index';
import Button from '../Button/index';
import AsyncTypeahead from '../Typeahead/async';
import type { OPTION_TYPE } from '../Typeahead/index';
import { Cancel, Search } from '../CommonTexts';

type RouteSearchPopoverPropTypes = {
  fetchRoutes: Function,
  onChange: Function,
  onRouteSelected: Function,
  relations: Array<Object>,
  closePopover: Function,
}


type RouteSearchPopoverStateTypes = {
  typeAheadValue: ?OPTION_TYPE
}

const customRenderItem = (item: Object, isHighlighted: boolean) => (
  <OmnisearchResult
    {...item}
    isSelected={isHighlighted}
    size="small"
  />
);

const customRenderSelected = (item, onClear) => {
  switch (item.result_type) {
    case OMNISEARCH_RESULT_TYPES.route: {
      return (
        <CloseableInputSearchResult
          title={`${item.name}`}
          subtitle="Ruta"
          closeAction={onClear}
        />
      );
    }
    default: return (
      <CloseableInputSearchResult
        title="N/A"
        subtitle="N/A"
        closeAction={onClear}
      />
    );
  }
};

class RouteSearchPopover extends React.Component<RouteSearchPopoverPropTypes,
  RouteSearchPopoverStateTypes> {
  constructor(props: RouteSearchPopoverPropTypes) {
    super(props);
    this.state = { typeAheadValue: null };
    return props.onChange && props.onChange(props.relations || []);
  }

  render() {
    const {
      closePopover,
      onRouteSelected,
      fetchRoutes,
    } = this.props;
    const { typeAheadValue } = this.state;
    return (
      <div className={styles.relationSearch}>
        <p className={styles.helpText}>Agrega a una ruta al monitor</p>
        <AsyncTypeahead
          name="routeSelect"
          isLocallyContained
          component={RenderTypeahead}
          inputDebounce={200}
          renderSelectedValue={customRenderSelected}
          renderLoading={() => <OmnisearchLoadingResults size="small" count={3} />}
          fetchItems={fetchRoutes}
          value={typeAheadValue}
          onChange={(selectedItem) => {
            this.setState({
              typeAheadValue: selectedItem,
            });
          }}
          renderItem={customRenderItem}

          inputProps={{
            Icon: MdSearch,
            iconPosition: 'right',
            placeholder: Search(i18n.t('labels.route', { count: 1 }), 1),
          }}
        />
        <div className={styles.buttonsContainer}>
          <Button
            title={Cancel()}
            tint="gray"
            isOutlined
            size="small"
            clearMargins
            type="button"
            onClick={closePopover}
          />
          <Button
            size="small"
            title={i18n.t('buttons.add')}
            className={styles.approveButton}
            onClick={() => {
              if (typeAheadValue !== null) {
                if (onRouteSelected) {
                  onRouteSelected(typeAheadValue);
                }
              }
            }}
            clearMargins
          />
        </div>
      </div>
    );
  }
}

const RouteSearchPopoverConnect = connect(
  (state, props) => {
    const token = selectors.getToken(state);
    const popoverId = props.id;
    const schoolId = (selectors.getProfileOfType(state, 'admin') || {}).school || -1;
    const fetchRoutes = generateFetcher(
      OMNISEARCH_RESULT_TYPES.route,
      schoolId,
      token,
    );
    return {
      fetchRoutes,
      popoverId,
    };
  },
  dispatch => ({
    close(id) {
      dispatch(closeableActions.close(id));
    },
  }),
  (propsFromState, propsFromDispatch, ownProps) => {
    const { popoverId } = propsFromState;
    const { close } = propsFromDispatch;
    return {
      ...ownProps,
      ...propsFromState,
      ...propsFromDispatch,
      closePopover: () => close(popoverId),
    };
  },
)(RouteSearchPopover);

export default RouteSearchPopoverConnect;



// WEBPACK FOOTER //
// ./src/scripts/components/RouteSearchPopover/index.jsx